import Api from '../api/reconApi';
import { normalizeInbox } from '../utils/notificationInboxDisplay';

/**
 * Hub inbox. `/api/notifications` is the older send log; the bell reads
 * `/api/hub_notifications`.
 *
 * GET hub_notifications                  all rows, `{ data: Notification[] }`
 * GET hub_notifications?unread=true      unread rows
 * GET hub_notifications/unread_count     `{ data: { unread_count } }`
 * POST hub_notifications/:id/mark_read
 * POST hub_notifications/mark_all_read
 *
 * Notification fields the panel reads (flat or JSON:API attributes):
 *   id, read | read_at, badge (New | Returned | Ready | Overdue),
 *   status (one line, e.g. "Starting in Detail" or "Service → Detail"),
 *   store_name, dealership (store subdomain),
 *   vehicle_id, department_id (vehicle's current step),
 *   year, make, model, stock, vin, created_at
 *
 * Opening the panel only GETs. Mark-read is an explicit POST.
 */

function unreadCountFrom(body) {
	if (!body || typeof body !== 'object') return null;
	const root = body.data && typeof body.data === 'object' && !Array.isArray(body.data)
		? body.data
		: body;
	const value = root.unread_count;
	if (value == null) return null;
	const count = Number(value);
	return Number.isFinite(count) ? count : null;
}

export function fetchUnreadCount() {
	return Api.get('hub_notifications/unread_count').then(unreadCountFrom);
}

export function fetchNotificationInbox(scope) {
	const listPath = scope === 'all'
		? 'hub_notifications'
		: 'hub_notifications?unread=true';
	return Promise.all([
		Api.get(listPath),
		Api.get('hub_notifications/unread_count').catch(() => null),
	]).then(([listBody, countBody]) => {
		const inbox = normalizeInbox(listBody);
		const unreadCount = unreadCountFrom(countBody);
		if (unreadCount != null) inbox.unreadCount = unreadCount;
		return inbox;
	});
}

export function markNotificationRead(id) {
	return Api.postNoBody(`hub_notifications/${id}/mark_read`);
}

export function markAllNotificationsRead() {
	return Api.postNoBody('hub_notifications/mark_all_read');
}
